import { Grid, Box } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import DesktopHeader from "./DesktopHeader";
import MobileHeader from "./MobileHeader";
import { useEffect, useRef, useState } from "react";
import AuthSidebar from "./Sidbar";
import useVirtualViewport from "../../../hooks/useVirtualViewport";
import { useAppDispatch, useAppSelector } from "../../../hooks/useRedux";
import { setOpenAuthSidebar } from "../../../redux/features/settingSlice";
import { toggleKeyboard } from "../../../redux/features/settingSlice";

export default function AuthLayout() {
  const [scrollY, setScrollY] = useState<number>(0);

  const { pathname } = useLocation();

  const dispatch = useAppDispatch();

  const viewport = useVirtualViewport();

  const [hasScroll, setHasScroll] = useState(false);

  const { isOpenKeyboard } = useAppSelector((state) => state.setting);

  useEffect(() => {
    dispatch(setOpenAuthSidebar(false));
  }, [pathname]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY || window.pageYOffset;
      setScrollY(currentScrollY);

      if (currentScrollY > 20) {
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    console.log(viewport);

    const handleResize = () => {
      if (viewport?.height) {
        if (viewport.height < window.innerHeight) {
          dispatch(toggleKeyboard(true));
        } else {
          dispatch(toggleKeyboard(false));
        }
      }
    };

    handleResize();
  }, [viewport?.height]);

  return (
    <Box
      sx={{
        direction: "rtl",
        height: isOpenKeyboard ? "" : `${viewport?.height}px`,
        minHeight: isOpenKeyboard ? "100vh" : "",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "background.paper",
      }}
    >
      <AuthSidebar />
      <DesktopHeader hasScroll={hasScroll} />
      <Outlet />
    </Box>
  );
}
